exports.components = {
  "component---pages-404-js": () => import("./../../../pages/404.js" /* webpackChunkName: "component---pages-404-js" */),
  "component---pages-index-js": () => import("./../../../pages/index.js" /* webpackChunkName: "component---pages-index-js" */),
  "component---src-game-js": () => import("./../../../src/Game.js" /* webpackChunkName: "component---src-game-js" */),
  "component---src-template-js": () => import("./../../../src/Template.js" /* webpackChunkName: "component---src-template-js" */)
}

